module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_icon_13.46276b65.png";